export default "__VITE_ASSET__gKjqx39z__"